import { OptionTitle } from "../../../../types/OptionTitle"

export const MaleMedicalHistoryOptions: Array<OptionTitle> = [
  { title: "Two or more miscarriages experienced by a partner", id: "TWO_PLUS_MISCARRIAGES_BY_PARTNER" },
  { title: "Infection in the pelvis or abdomen", id: "INFECTION_PELVIC_ABDOMEN" },
  { title: "Sexually transmitted infection (STD/STI)", id: "STD_STI" },
  { title: "Varicocele", id: "VARICOCELE" },
  { title: "Mumps", id: "MUMPS" },
  { title: "Vasectomy", id: "VASECTOMY" },
  { title: "Vasectomy reversal", id: "VASECTOMY_REVERSAL" },
  { title: "Hernia repair (inguinal or groin)", id: "HERNIA_REPAIR" },
  { title: "Testicular surgery", id: "TESTICULAR_SURGERY" },
  {
    title: "Erectile dysfunction, ejaculatory dysfunction, or difficulty with intercourse",
    id: "ERECTILE_DYSFUNCTION"
  }
]

export const FemaleMedicalHistoryOptions: Array<OptionTitle> = [
  { title: "Sexually transmitted infection (STD/STI)", id: "STD_STI" },
  { title: "Pelvic inflammatory disease (PID)", id: "PID" },
  { title: "Infection in the pelvis or abdomen", id: "INFECTION_PELVIC_ABDOMEN" },
  { title: "Endometriosis", id: "ENDOMETRIOSIS" },
  { title: "Uterine fibroids", id: "UTERINE_FIBROIDS" },
  { title: "Uterine scarring or Asherman syndrome", id: "UTERINE_SCARRING_ASHERMAN" },
  { title: "Uterine polyps", id: "UTERINE_POLYPS" },
  { title: "Polycystic ovary syndrome (PCOS)", id: "PCOS" },
  { title: "Pain or difficulty with intercourse", id: "PAIN_INTERCOURSE" },
  { title: "Pelvic or abdominal surgery", id: "PELVIC_ABDOMEN_SURGERY" }
]

export const MaleConditionsOptions: Array<OptionTitle> = [
  { title: "Diabetes", id: "DIABETES" },
  { title: "High blood pressure", id: "HIGH_BLOOD_PRESSURE" },
  { title: "Autoimmune disease", id: "AUTOIMMUNE_DISEASE" },
  { title: "Obesity (BMI greater than 30)", id: "OBESITY" }
]

export const FemaleConditionsOptions: Array<OptionTitle> = [
  { title: "Diabetes", id: "DIABETES" },
  { title: "High blood pressure", id: "HIGH_BLOOD_PRESSURE" },
  { title: "Autoimmune disease that affects your hormones ", id: "HORMONE_AFFECTING_AUTOIMMUNE_DISEASE" }
]

export const MaleFamilyConditionsOptions: Array<OptionTitle> = [
  { title: "Recurrent pregnancy loss", id: "RECURRENT_PREGNANCY_LOSS" },
  { title: "Birth defects or genetic disorders", id: "BIRTH_DEFECTS_GENETIC_DISORDERS" }
]

export const FemaleFamilyConditionsOptions: Array<OptionTitle> = [
  { title: "Infertility", id: "INFERTILITY" },
  { title: "Recurrent pregnancy loss", id: "RECURRENT_PREGNANCY_LOSS" },
  { title: "Menopause before age 40", id: "MENOPAUSE_BEFORE_40" },
  { title: "Blood clotting or bleeding disorder", id: "BLOOD_CLOTTING_BLEEDING_DISORDER" },
  { title: "Chronic disease such as diabetes or high blood pressure", id: "CHRONIC_DISEASE" },
  { title: "Birth defects or genetic disorders", id: "BIRTH_DEFECTS_GENETIC_DISORDERS" }
]

export const MaleCurrentlyTakingOptions: Array<OptionTitle> = [
  { title: "Multivitamin", id: "MULTIVITAMIN" },
  { title: "Testosterone", id: "TESTOSTERONE" },
  { title: "Other hormone", id: "OTHER_HORMONE" }
]

export const FemaleCurrentlyTakingOptions: Array<OptionTitle> = [
  { title: "Prenatal vitamins", id: "PRENATAL_VITAMINS" },
  { title: "Multivitamin", id: "MULTIVITAMIN" },
  { title: "Vitamin D", id: "VITAMIN_D" },
  { title: "Contraceptive such as birth control pills, IUD, implant, or injectable", id: "CONTRACEPTIVE" },
  { title: "Hormones", id: "HORMONES" }
]

export const SmokeDrinkOptions: Array<OptionTitle> = [
  { title: "I smoke cigarettes daily", id: "CIGARETTES_DAILY" },
  { title: "I quit smoking", id: "QUIT_SMOKING" },
  { title: "I use marijuana", id: "MARIJUANA" },
  { title: "I exercise regularly", id: "EXERCISE_REGULARLY" },
  { title: "I consume three or more servings of alcohol a week", id: "THREE_PLUS_ALCOHOLS_WEEKLY" },
  { title: "I consume one or more servings of caffeine a day", id: "ONE_PLUS_COFFEE_DAILY" },
  {
    title: "I have had environmental exposure at a level known to impact fertility",
    id: "ENVIRONMENTAL_EXPOSURE_IMPACTING_FERTILITY"
  },
  {
    title: "I have had radiation exposure at a level known to impact fertility",
    id: "RADIATION_EXPOSURE_IMPACTING_FERTILITY"
  }
]

export const FemaleExperiencingSymptomsOptions: Array<OptionTitle> = [
  { title: "Moderate to severe acne", id: "ACNE" },
  {
    title: "Unexpected hair growth on the face, chest, nipples, lower abdomen, or lower back",
    id: "UNEXPECTED_HAIR_GROWTH"
  },
  { title: "Significant hair loss", id: "HAIR_LOSS" },
  { title: "Unexplained weight gain or loss", id: "WEIGHT_CHANGE" },
  { title: "Chronic fatigue", id: "CHRONIC_FATIGUE" }
]

export const MaleExperiencingSymptomsOptions: Array<OptionTitle> = [
  { title: "Significant hair loss", id: "HAIR_LOSS" },
  { title: "Unexplained weight gain or loss", id: "WEIGHT_CHANGE" },
  { title: "Chronic fatigue", id: "CHRONIC_FATIGUE" }
]

export const CycleDetails: Array<OptionTitle> = [
  { title: "I've never had a period", id: "NEVER_HAD_PERIOD" },
  { title: "Sometimes I skip months", id: "SKIP_MONTHS" },
  { title: "I have bleeding or spotting in between my periods", id: "SPOTTING_BETWEEN" },
  { title: "I'm not sure", id: "NOT_SURE" }
]

export const PeriodsPainfulDetails: Array<OptionTitle> = [
  { title: "Pain with intercourse", id: "PAINFUL_INTERCOURSE" },
  { title: "Pain with bowel movements or urination", id: "PAINFUL_BOWEL_URINATION" },
  { title: "Very heavy bleeding", id: "HEAVY_BLEEDING" }
]

export const PregnantPreviouslyDetails: Array<OptionTitle> = [
  { title: "Preterm birth", id: "PRETERM_BIRTH" },
  { title: "Unintended pregnancy loss", id: "UNINTENDED_LOSS" },
  { title: "Pregnancy achieved via fertiility treatment", id: "VIA_FERTILITY_TREATMENT" },
  { title: "Ectopic pregnancy", id: "ECTOPIC_PREGNANCY" }
]

export const PelvicSurgeryDetails: Array<OptionTitle> = [
  { title: "Bilateral tubal ligation (”tied my tubes”)", id: "TUBES_TIED" },
  { title: "Other tubal surgery", id: "OTHER_TUBAL_SURGERY" },
  { title: "Removal of fibroids", id: "REMOVED_FIBROIDS" },
  { title: "Removal of polyps in uterus", id: "REMOVED_POLYPS_IN_UTERUS" },
  { title: "Removal of septum in uterus", id: "REMOVED_SEPTUM_IN_UTERUS" },
  { title: "One ovary removed", id: "ONE_OVARY_REMOVED" },
  { title: "Two ovaries removed", id: "TWO_OVARIES_REMOVED" }
]
